import React from 'react'
import { useDrop } from 'react-dnd'
import { useSelector } from 'react-redux'
import NumberFormat from 'react-number-format'
// import DragIcon from '../../assets/new-design/transfers/drag.svg'
import { getCurrentAccDetailsSelector } from '../../store/selectors/app.selector'
import { useTranslation } from 'react-i18next'
import { BENEFICIARY_DROP_TARGET_KEYS } from '../../utils/translation-constants'

export default function BeneficiaryDropTarget() {
  const currentAccountDetail = useSelector(getCurrentAccDetailsSelector)
  const { t } = useTranslation()

  const [{ canDrop, isOver }, drop] = useDrop({
    accept: 'BeneficiaryGridItem',
    drop: () => ({ name: 'Transfer Drop Target' }),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })

  console.log(currentAccountDetail)
  const isActive = canDrop && isOver

  let opacity = 1

  if (isActive) {
    opacity = 0.5
  } else if (canDrop) {
    opacity = 1
  }

  return (
    <div ref={drop} className='drop-target' style={{ opacity }}>
      <div className=''>
        <p className=''>{t(BENEFICIARY_DROP_TARGET_KEYS.HEADER)}</p>
        <div className='drag-drop'></div>
        {/* <img
          style={{ position: 'absolute', left: 100, top: 140 }}
          src={DragIcon}
          width={50}
          height={51}
        /> */}
        <div className='balance-section'>
          <p>{t(BENEFICIARY_DROP_TARGET_KEYS.AVAILABLE_BALANCE)}</p>
          <h5>
            <NumberFormat
              className='balance'
              // value={selectedAccount?.AVL_BALANCE}
              value={currentAccountDetail?.avlBal}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />

            <span className='font-weight-500' style={{ marginLeft: 5 }}>
              {currentAccountDetail?.currency}
            </span>
          </h5>
        </div>
      </div>
    </div>
  )
}
